<template><ContactSubPage :title="{ 'zh-CN': '加入我们', 'en-US': 'Careers' }" /></template>
<script>
import ContactSubPage from "./ContactSubPage.vue";
export default { name: "CareersPage", components: { ContactSubPage } };
</script>
